import styled from 'styled-components';
import { Button } from '@simplywallst/ui-core';

export const AddNoteButton = styled(Button)`
  position: absolute;
  bottom: ${({ theme }) => theme.x2spacePx}px;
  left: 50%;
  transform: translateX(-50%);

  text-decoration: none;
  padding: 0 ${({ theme }) => theme.x2spacePx}px;
  border-radius: 9999px;
`;
